// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"63458206","703":"883b8440"}[chunkId] + ".chunk.js";
};